import inspectorUnselectedImg from '../../assets/icons/pin_inspector_unselected.png'; // Adjust path as needed
import inspectorSelectedImg from '../../assets/icons/pin_inspector_selected.png';
import projectUnselectedImg from '../../assets/icons/pin_project_unselected.png';
import projectSelectedImg from '../../assets/icons/pin_project_selected.png';
import projectScheduledImg from '../../assets/icons/pin_project_scheduled.png';
// If using public/ folder instead: import inspectorUnselected from '../public/images/pin_inspector_unselected.png';

export const image = () => ({ 
  url: projectUnselectedImg,
  origin: new window.google.maps.Point(0, 0),
  anchor: new window.google.maps.Point(0, 20),
  size: new window.google.maps.Size(30, 30), // Fixed typo: was 'site'
});

export const selectedImage = () => ({
  url: projectSelectedImg,
  origin: new window.google.maps.Point(0, 0),
  anchor: new window.google.maps.Point(0, 20),
  size: new window.google.maps.Size(30, 30),
});

export const inspectorImage = () => ({
  url: inspectorUnselectedImg,
  origin: new window.google.maps.Point(0, 0),
  anchor: new window.google.maps.Point(0, 20),
  size: new window.google.maps.Size(30, 30),
});

export const inspectorSelected = () => ({
  url: inspectorSelectedImg,
  origin: new window.google.maps.Point(0, 0),
  anchor: new window.google.maps.Point(0, 20),
  size: new window.google.maps.Size(30, 30),
});

export const inspectorOther = () => ({
  url: projectScheduledImg,
  origin: new window.google.maps.Point(0, 0),
  anchor: new window.google.maps.Point(0, 20),
  size: new window.google.maps.Size(30, 30),
});

export const otherIntakes = () => ({
  url: `https://maps.gstatic.com/mapfiles/ms2/micons/mechanic.png`, // Keep external if rarely used
  origin: new window.google.maps.Point(0, 0),
  anchor: new window.google.maps.Point(0, 20),
  size: new window.google.maps.Size(30, 30),
});

export const shape = {
  coords: [1, 1, 40, 70, 40, 1, 1, 1],
  type: 'poly',
};